import { render, staticRenderFns } from "./selectMaterialModal.vue?vue&type=template&id=272ffaf4&scoped=true"
import script from "./selectMaterialModal.vue?vue&type=script&lang=js"
export * from "./selectMaterialModal.vue?vue&type=script&lang=js"
import style0 from "./selectMaterialModal.vue?vue&type=style&index=0&id=272ffaf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272ffaf4",
  null
  
)

export default component.exports